export function arrayOfIntegers(length: number, max: number = 100) {
  return Array.from({ length: length }, () => Math.floor(Math.random() * max))
}
